export default "__VITE_ASSET__DRsouFYB__"